import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: column;
  }
`;

export const GuestItemWrapper = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 10px 20px;
  border: 1px solid ${({ theme }) => theme.palette.iron};
  border-radius: 8px;
`;

export const DateInputRow = styled.div`
  margin-top: 20px;
  &:after {
    content: '';
    display: table;
    clear: both;
  }
`;

export const DateInputCol = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 45%;
  margin-right: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 100%;
  }
`;

export const ChildAnimationErrorBox = styled.div<{
  hasError: boolean;
  hasAnimationOnError?: boolean;
  borderRadius?: string;
}>`
  flex: 1;
  height: fit-content;
  ${({ hasError, hasAnimationOnError = true, borderRadius = '0' }) =>
    hasError &&
    css`
      border-radius: ${borderRadius};

      animation: ${() =>
        hasAnimationOnError &&
        'shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)'};
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;
